import * as ko from "knockout";
import { dynamicFieldProperties, ui_tab } from "ui";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";
import * as _ from "lodash";

class DynamicFieldsService extends BaseService {
  constructor() {
    super("dynamicFields");
  }

  public searchDynamicFields = async (fields: string[]): Promise<dynamicFieldProperties[]> => {
    const data = await portalHttpService.post<any[]>(
      `${this.baseApiUrl()}/SearchDynamicFields`,
      ko.toJSON({ fields: fields }),
    );
    return data.map((field) => new dynamicFieldProperties(field));
  };

  public getUiTabs = async (page: string) => {
    const urlResult = new URL(`${this.baseApiUrl()}/GetUiTabs`);
    urlResult.searchParams.append("page", page);
    let data: any[] = await portalHttpService.get(urlResult.href);

    data = _.orderBy(data, ["sequence"], ["asc"]);

    let result = data.map(
      (field) =>
        new ui_tab({
          href: field.href,
          label: field.tab_name,
          isActive: field.active === "Y",
          hasChartButton: field.has_chart_button === "Y",
        }),
    );
    return result;
  };
}

export const dynamicFieldsService = new DynamicFieldsService();
